<script>
</script>

<div class="Card">
	<slot />
</div>

<style lang="scss">
	.Card{
		display: flex;
		align-items: center;
		padding: 1rem;
		border: 2px solid var(--border-color);
		border-radius: 20px;
	}
</style>
